module.exports = __webpack_public_path__ + "static/sparkle-24-7-d8d630d12609cb2dc5e575fb53d56d70.svg";